import React from "react";
import Slider from "react-animated-slider";
import "react-animated-slider/build/horizontal.css";
import "./CarouselStyle.css";
import { Box } from "@mui/material";
import Green from "../../assets/images/CarouselImageGree.jpeg";
import Humanist from "../../assets/images/CarouselImageHumanist.jpeg";
import Progressive from "../../assets/images/CarouselImageProgressive.jpeg";
import Youth from "../../assets/images/CarouselImageYouth.jpeg";
import Reformist from "../../assets/images/CarouselImageReformist.jpeg";
import Link from "react-scroll/modules/components/Link";

const content = [
  {
    title: "A GREEN INITIATIVE",

    image: Green,
  },
  {
    title: "A YOUTHFUL INITIATIVE",

    image: Youth,
  },
  {
    title: "A REFORMIST INITIATIVE ",

    image: Reformist,
  },
  {
    title: "A HUMANIST INITIATIVE",

    image: Humanist,
  },
  {
    title: "A PROGRESSIVE INITIATIVE",

    image: Progressive,
  },
];
const Carousel = () => (
  <Slider className="slider-wrapper h-[420px] lg:h-[600px] 2xl:h-[800px]">
    {content.map((item, index) => (
      <Box
        key={index}
        className="slider-content"
        style={{
          background: `url('${item.image}') no-repeat center center`,
        }}
      >
        <Box className="inner">
          <h1
            style={{
              background:
                "linear-gradient(to left, rgba(255,255,255,0.4), rgba(255,255,255,0))",
              borderRadius: "25px",
              padding: "1rem",
            }}
            className="font-['FuturaExtraBold'] text-2xl md:text-3xl lg:text-4xl xl:text-5xl"
          >
            {item.title}
          </h1>
          <Link to="Reg" spy={true} smooth={true}>
            <button className="font-['FuturaExtraBold'] rounded-3xl bg-[#00693A] text-[#ffffff] px-10 py-4 xl:px-14 xl:py-5 shadow-2xl text-2xl md:text-3xl lg:text-4xl xl:text-5xl">
              JOIN US
            </button>
          </Link>
        </Box>
      </Box>
    ))}
  </Slider>
);

export default Carousel;
